<template>
  <div class="showcase-home-hero-footer">
    <div class="stack" v-for="(stack, index) in stacks" :key="index">
      <div class="showcase-slide-up" :style="stackStyle(index)">
        <StackIcon :name="stack" color="#fff" background="light" size="47" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import StackIcon from '@/stack/components/stack-icon';

export default defineComponent({
  name: 'ShowcaseHomeHeroFooter',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      stacks: [
        'node',
        'vue',
        'typescript',
        'css',
        'git',
        'github',
        'centos',
        'nginx',
        'mysql',
        'alipay',
        'wxpay',
      ],
    };
  },

  /**
   * 计算属性
   */
  computed: {},

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    stackStyle(index) {
      const delayValue = `${(index + 1) * 0.1}s`;

      return {
        'animation-delay': delayValue,
      };
    },
  },

  /**
   * 使用组件
   */
  components: {
    StackIcon,
  },
});
</script>

<style scoped>
@import './styles/showcase-home-hero-footer.css';
</style>
